module.exports = __webpack_public_path__ + "files/SPIADI - Synthèse des recommandations - CVP courts et midline sans PI.aa58373c68fbc053325a3bc7a8717f09.pdf";